var $ = jQuery;



function init() {
  const $form = $('.contact__contact-forms');
  const $select = $form.find('.filter-wrapper__filter');
  const $target = $('.contact-target');

  if ($form.length > 0) {
    binds();
  }

  function binds() {
    $select.on('change', toggleBody);
  }


  function toggleBody() {
    let $selector = $('.'+$(this).val());
    $target.removeClass('_active');
    $selector.addClass('_active');
  }
}

export {init as init};

